<template>
  <v-dialog v-model="dialog" max-width="1100px" eager origin="center">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>Pré-Venda #{{ preSale.id }}</span>
        <PreSaleStatusChip v-if="preSale.status" :value="preSale.status" />
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <small class="text-secondary">Nome/Cliente</small>
            <br />
            <span class="text--primary">{{ preSale.name || "-" }}</span>
          </v-col>
          <v-col cols="6">
            <small class="text-secondary">Origem</small>
            <br />
            <PreSaleOriginChip v-if="preSale.origin" :value="preSale.origin" />
            <span v-else class="text--primary">-</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <small class="text-secondary">Data de Criação</small>
            <br />
            <span class="text--primary">
              {{ $format.dateTimeBr(preSale.created_at) }}
            </span>
          </v-col>
          <v-col cols="4">
            <small class="text-secondary">Total à Vista</small>
            <br />
            <span class="text--primary text-h6 success--text">
              R${{ $format.decimal(preSale.total_cash) }}
            </span>
          </v-col>
          <v-col cols="4">
            <small class="text-secondary">Total a Prazo</small>
            <br />
            <span class="text--primary text-h6">
              R${{ $format.decimal(preSale.total_forward) }}
            </span>
          </v-col>
        </v-row>

        <h3 class="mt-6 mb-2">Itens</h3>
        <v-data-table
          :headers="headers"
          :items="preSale.items"
          :items-per-page="-1"
          hide-default-footer
          disable-sort
          dense
        >
          <template v-slot:[`item.product`]="{ item }">
            <span v-if="item.product">{{ item.product.name }}</span>
            <span v-else class="text--secondary">
              Produto #{{ item.product_id }}
            </span>
          </template>

          <template v-slot:[`item.quantity`]="{ item }">
            {{ $format.decimal(item.quantity) }}
          </template>

          <template v-slot:[`item.price_cash`]="{ item }">
            R${{ $format.decimal(item.price_cash) }}
          </template>

          <template v-slot:[`item.price_forward`]="{ item }">
            R${{ $format.decimal(item.price_forward) }}
          </template>

          <template v-slot:[`item.total_price_cash`]="{ item }">
            R${{ $format.decimal(item.total_price_cash) }}
          </template>

          <template v-slot:[`item.total_price_forward`]="{ item }">
            R${{ $format.decimal(item.total_price_forward) }}
          </template>

          <template v-slot:[`body.append`]>
            <tr class="font-weight-bold">
              <td colspan="5" class="text-right">Totais:</td>
              <td class="text-right">
                R${{ $format.decimal(preSale.total_cash) }}
              </td>
              <td class="text-right">
                R${{ $format.decimal(preSale.total_forward) }}
              </td>
            </tr>
          </template>
        </v-data-table>

        <template v-if="preSale.converted_at">
          <v-divider class="my-4" />
          <v-row>
            <v-col>
              <small class="text-secondary">Convertido em</small>
              <br />
              <span class="text--primary success--text">
                {{ $format.dateTimeBr(preSale.converted_at) }}
              </span>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions
        class="justify-end py-4"
        style="background-color: #f5f5f5"
      >
        <v-btn class="text-capitalize" color="success" @click="handleConvert()">
          <v-icon left>mdi-cart-arrow-right</v-icon>
          Converter em Venda
        </v-btn>
        <v-btn
          @click="dialog = false"
          text
          class="text-capitalize"
          color="secondary"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PreSaleStatusChip from "./PreSaleStatusChip.vue";
import PreSaleOriginChip from "./PreSaleOriginChip.vue";

export default {
  components: {
    PreSaleStatusChip,
    PreSaleOriginChip,
  },
  data: () => ({
    dialog: false,
    id: null,
    preSale: {
      items: [],
    },

    headers: [
      { text: "Produto", value: "product" },
      { text: "Código", value: "product_code" },
      { text: "Qtd", value: "quantity", align: "right" },
      { text: "Preço à Vista", value: "price_cash", align: "right" },
      { text: "Preço a Prazo", value: "price_forward", align: "right" },
      { text: "Total à Vista", value: "total_price_cash", align: "right" },
      { text: "Total a Prazo", value: "total_price_forward", align: "right" },
    ],
  }),

  methods: {
    async open(id) {
      this.id = id;

      await this.loadPreSale();

      this.dialog = true;
    },

    async loadPreSale() {
      let response = await this.$http.show("sale/pre-sale", this.id);

      this.preSale = response.preSale;
    },

    async handleConvert() {
      this.$emit("convert", this.preSale.id);

      this.dialog = false;
    },
  },
};
</script>
